const STORAGE_KEY = "agrokoll:registrationRedirects";
const WINDOW_MS = 60_000;
const MAX_REDIRECTS_IN_WINDOW = 2;

const readTimestamps = (): number[] => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((t): t is number => typeof t === "number") : [];
  } catch {
    return [];
  }
};

const writeTimestamps = (timestamps: number[]): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(timestamps));
  } catch {
    // Storage unavailable (private mode, quota): the breaker degrades to "always allow".
  }
};

/**
 * Record a redirect to Agronod konto and say whether it may go ahead.
 *
 * Algorithm:
 * 1. Read the timestamps of earlier redirects for this tab from sessionStorage.
 * 2. Drop those older than the window.
 * 3. Refuse when the limit is already reached; otherwise record now and allow.
 *
 * agrokoll and Agronod konto redirect to each other unconditionally based on the
 * `registered` claim. One extra hop is legitimate (Keycloak may read the claim
 * before fence's write is visible) and an abandoned registration hours later is
 * a single hop again. A real disagreement between the two apps bounces every few
 * seconds through Keycloak, and that is what this stops.
 *
 * @param now - current time in ms; injectable for tests
 * @returns true when the redirect may proceed
 */
export const recordRegistrationRedirect = (now: number = Date.now()): boolean => {
  const recent = readTimestamps().filter((t) => now - t < WINDOW_MS);
  if (recent.length >= MAX_REDIRECTS_IN_WINDOW) {
    return false;
  }
  writeTimestamps([...recent, now]);
  return true;
};
